var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.333414 7.00033C0.333414 7.8758 0.505852 8.74271 0.840883 9.55155C1.17591 10.3604 1.66698 11.0953 2.28604 11.7144C3.53628 12.9646 5.23197 13.667 7.00008 13.667C8.76819 13.667 10.4639 12.9646 11.7141 11.7144C12.9644 10.4641 13.6667 8.76844 13.6667 7.00033C13.6667 6.12485 13.4943 5.25794 13.1593 4.4491C12.8242 3.64026 12.3332 2.90534 11.7141 2.28628C11.0951 1.66722 10.3601 1.17616 9.5513 0.841127C8.74247 0.506096 7.87556 0.333658 7.00008 0.333658C5.23197 0.333658 3.53628 1.03604 2.28604 2.28628C1.03579 3.53652 0.333414 5.23221 0.333414 7.00033ZM10.3334 7.00033L7.00008 10.3337V8.33366H4.33341V5.66699H7.00008V3.66699L10.3334 7.00033Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.490ecbe8.svg";
export { ForwardRef as ReactComponent };